module.exports = __webpack_public_path__ + "static/media/my young roots bundled in a ball I was transported.1c2d0a5f.png";